import React, { useCallback, useEffect, useState } from "react";
import useDarkMode from '../../../hooks/useDarkMode';
import axiosInstance from "../../../config/axiosApi/axiosApi";
import APIs from "../../../Constants/apis";
import Select from "react-select";
import DropDownStyles, { DropDownStylesDark } from "../../../pages/staff/dropdownStyles";
import { useSelector } from "react-redux";

const CustomerGroupSelector = ({ selectedGroup, onChange,setSelectedGroup, setLoading }) => {
  const CompID = useSelector((state) => state.auth.user).userData?.compID;
  const [customerGroups, setCustomerGroups] = useState([]);

  // Check if dark mode is enabled
  const isDarkMode = useDarkMode();

  // Select appropriate dropdown styles based on theme
  const dropdownStyles = isDarkMode ? DropDownStylesDark : DropDownStyles;

  const fetchCustomerGroups = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        APIs.GET_ALL_CUSTOMERS_GROUP_TYPE_LIST,{
          params:{
            CompID
          }
        }
      );
      const groupData = response.data.data || response.data;
 
      setCustomerGroups(
        groupData.map((group) => ({
          value: group.id,
          label: group.name,
        }))
      );
    } catch (err) {
      // Error fetching customer groups silently
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  useEffect(() => {
    fetchCustomerGroups();
  }, [fetchCustomerGroups]);

  return (
    <Select
      value={customerGroups.find((option) => option.value === selectedGroup)}
      onChange={(option) => {setSelectedGroup(option?.value || "")}}
      options={customerGroups}
      styles={dropdownStyles}
      isClearable={true}
      placeholder="Select Group"
    />
  );
};

export default CustomerGroupSelector;
